export const SET_USER_PARAMETER = "SET_USER_PARAMETER";